import React, { FC } from 'react';
import Button from 'src/components/Button';
import { ProviderCompanyType } from 'src/types/providerCompany';

export interface ProviderCompanySelectorPropsType {
    providerCompaniesData: ProviderCompanyType[];
    data?: ProviderCompanyType | null;
    setData: (item: ProviderCompanyType) => void;
}

const ProviderCompanySelector: FC<ProviderCompanySelectorPropsType> = (props) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {props.providerCompaniesData.map((item) => (
                <Button
                    color="primary"
                    key={item.ID}
                    variant={props.data === item ? 'contained' : 'outlined'}
                    fullWidth
                    onClick={() => props.setData(item)}
                    sx={{ justifyContent: 'flex-start', textAlign: 'left', padding: '12px' }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                        <div>{`${item.RECIPIENT_NAME || ''} / ${item.CONTACT_PERSON || ''} / ${item.COMPANY_NAME || ''}`}</div>
                    </div>
                </Button>
            ))}
        </div>
    );
};

export default ProviderCompanySelector;
